import { Typography } from '@euler/app/components/typography';
import { CardNotice } from '@euler/app/flows/ai-suite/components/ChatCard';
import { aiColors, tint } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiDatasetUsage } from '@euler/model/bi/library';
import { ChevronRight, LayoutDashboard } from 'lucide-react-native';
import { memo } from 'react';
import { Pressable, View } from 'react-native';
import { DetailSection } from './DetailSection';

/** Where the dataset is used: the dashboards the caller sees, and others. */
export const UsageSection = memo(
  ({
    usage,
    onOpenDashboard,
  }: {
    usage: BiDatasetUsage;
    onOpenDashboard: (dashboardId: string) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <DetailSection title="用在哪些看板">
        {usage.dashboards.length || usage.hiddenDashboardCount ? null : (
          <CardNotice text="还没有看板用到这份数据。" />
        )}
        {usage.dashboards.map(dashboard => (
          <Pressable
            key={dashboard.dashboardId}
            accessibilityRole="link"
            accessibilityLabel={`打开看板 ${dashboard.name}`}
            onPress={() => onOpenDashboard(dashboard.dashboardId)}
            style={({ pressed }) => ({
              flexDirection: 'row',
              alignItems: 'center',
              gap: rpx(10),
              opacity: pressed ? 0.7 : 1,
            })}
          >
            <View
              style={{
                width: rpx(28),
                height: rpx(28),
                borderRadius: rpx(8),
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: tint(aiColors.amber, 0.14),
              }}
            >
              <LayoutDashboard size={15} color={aiColors.amber} />
            </View>
            <Typography.Text
              size={rpx(13)}
              color={aiColors.foreground}
              numberOfLines={1}
              style={{ flex: 1 }}
            >
              {dashboard.name}
            </Typography.Text>
            <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
              {dashboard.cardCount} 张图表
            </Typography.Text>
            <ChevronRight size={15} color={aiColors.mutedForeground} />
          </Pressable>
        ))}
        {usage.hiddenDashboardCount ? (
          <CardNotice
            text={`另有 ${usage.hiddenDashboardCount} 个你看不到的看板也在用。`}
          />
        ) : null}
      </DetailSection>
    );
  },
);
